module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-immobiliare.c74430491163d886620030925782d42b.png";